module.exports = __webpack_public_path__ + "img/1949_no.22abe8a4.svg";